    const FormHelper = require("./FormHelper");
    const eventEmitter = require("event-emitter");

/* ======================================================================
	Submit Token With Form
	===================================================================== */

    var TokenHandler = function(rootElement) {
        this.formHelper = new FormHelper(rootElement);
    }

    eventEmitter(TokenHandler.prototype);

    TokenHandler.prototype.tokenObject = {};

    TokenHandler.prototype.responeHandler = function(response) {
        this.parseResponse(response);
        this.setValues();
        this.emit("tokenSet");
    }

    TokenHandler.prototype.setForm = function(element) {
        this.form = element;
    }

    TokenHandler.prototype.parseResponse = function(response) {
        this.tokenObject = response.opaqueData;
    }

    TokenHandler.prototype.setValues = function() {
        for (var property in this.tokenObject) {
            if (this.tokenObject.hasOwnProperty(property)) {
                this.setValue(property, this.tokenObject[property]);
            }
        }
    }

    TokenHandler.prototype.setValue = function(inputName, value) {
        this.formHelper.setValueByAnetName(inputName, value);
    }

    module.exports = TokenHandler;